import { render, staticRenderFns } from "./BalanceQuery.vue?vue&type=template&id=73cc25c3"
import script from "./BalanceQuery.vue?vue&type=script&lang=js"
export * from "./BalanceQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports